// ===============================================================================
// App.js - Main Application Component for SplitMon (PWA Enabled)
// ===============================================================================
// Location: /var/www/wow/frontend/src/App.js
// Updated: Added PWA InstallPWA component for install prompts
// ===============================================================================

import React, { useState, useEffect } from "react";
import LandingPage from "./LandingPage";
import Login from "./Login";
import Sidebar from "./Sidebar";
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import InstallPWA from './InstallPWA';
import "./App.css";

function App() {
  // ===============================================================================
  // State Management
  // ===============================================================================
  const [currentView, setCurrentView] = useState("landing"); // "landing", "login", "app"
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [user, setUser] = useState(null);

  // ===============================================================================
  // URL Path Detection (for direct links like password reset)
  // ===============================================================================
  useEffect(() => {
    const path = window.location.pathname;
    
    if (path === "/forgot-password") {
      setCurrentView("forgot-password");
    } else if (path === "/reset-password") {
      setCurrentView("reset-password");
    } else if (path === "/login") {
      setCurrentView("login");
    }
  }, []);

  // ===============================================================================
  // Navigation Handlers
  // ===============================================================================
  const handleNavigateToLogin = () => {
    setIsRegisterMode(false);
    setCurrentView("login");
  };

  const handleNavigateToSignup = () => {
    setIsRegisterMode(true);
    setCurrentView("login");
  };

  const handleBackToLanding = () => {
    setCurrentView("landing");
  };

  // ===============================================================================
  // Login Handler
  // ===============================================================================
  const handleLogin = (userData) => {
    console.log('✅ User logged in:', userData);
    setUser(userData);
    setCurrentView("app");
  };

  // ===============================================================================
  // Logout Handler
  // ===============================================================================
  const handleLogout = () => {
    console.log('🚪 User logged out');
    setUser(null);
    setCurrentView("landing");
  };

  // ===============================================================================
  // Render
  // ===============================================================================
  return (
    <div className="app">
      {/* PWA Install Prompt Component */}
      <InstallPWA />
      
      {currentView === "landing" && (
        <LandingPage 
          onNavigateToLogin={handleNavigateToLogin}
          onNavigateToSignup={handleNavigateToSignup}
        />
      )}
      
      {currentView === "login" && (
        <Login 
          onLogin={handleLogin}
          initialRegisterMode={isRegisterMode}
          onBackToLanding={handleBackToLanding}
          onForgotPassword={() => setCurrentView("forgot-password")}
        />
      )}

      {currentView === "forgot-password" && (
        <ForgotPassword onBackToLogin={() => setCurrentView("login")} />
      )}
      
      {currentView === "reset-password" && (
        <ResetPassword onBackToLogin={() => setCurrentView("login")} />
      )}

      {currentView === "app" && (
        <Sidebar 
          user={user}
          onLogout={handleLogout} 
        />
      )}
    </div>
  );
}

export default App;
